<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link>|
      <router-link to="/bot">Bot</router-link>|
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import api from "./api";
export default {
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    fetchUser() {
      api.getMe().then(
        response => {
          const account = JSON.stringify(response.data.data);
          this.$store.commit("SaveAccount", account);
        },
        error => {
          this.isLoading = false;
        }
      );
    },
    authUser(code) {
      api.authenticate(code).then(
        response => {
          localStorage.setItem(
            "Authorization",
            response.data.data.authentication_token
          );
          this.$router.push("/");
          this.fetchUser();
          this.isLoading = false;
        },
        error => {
          console.error(error);
        }
      );
    }
  },
  created: function() {
    const code = this.$route.query.code;
    if (code === undefined || code === "") {
      this.fetchUser();
    } else {
      this.isLoading = true;
      this.authUser(code);
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  text-align: center;
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

@import "~bulma/sass/utilities/_all";
// Set your colors
$primary: #8c67ef;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);
// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;
// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
